import { compose } from 'recompose';

import DatesRangeSelector from 'components/form/RecurringForm/components/DatesRangeSelector/component';

const enhance = compose();

export default enhance(DatesRangeSelector);
